module.exports = __webpack_public_path__ + "img/talk_8.1514ef9a.png";